

import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, getToken, getCurrentLanguage } from "../../shared/utils.js/utils";
import { saveRequest } from '../../shared/utils.js/offlineQueue';

// get taxes 
export const getTaxes = createAsyncThunk(
  "Tax/getTaxes",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.search) queryParams.append("search", params.search);
      if (params.status !== undefined && params.status !== "") queryParams.append("status", params.status);
      if (params.sort_by) queryParams.append("sort_by", params.sort_by);
      if (params.sort_order) queryParams.append("sort_order", params.sort_order);
      const url = `${BASE_URL}/taxes${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}`, "Accept-Language": currentLang },
      });
      return { data: response.data, params };
    } catch (error) {
      const message = error.response?.data?.message || "Failed to get taxes!";
      return rejectWithValue(message);
    }
  }
);

// add tax
export const addTax = createAsyncThunk(
  "Tax/addTax",
  async (payload, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.post(`${BASE_URL}/taxes`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


//update tax 
export const updateTax = createAsyncThunk(
  "Tax/updateTax",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.put(`${BASE_URL}/taxes/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


// get tax details 
export const getTaxDetails = createAsyncThunk(
  "Tax/getTaxDetails",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.get(`${BASE_URL}/taxes/${id}`, {
        headers: { Authorization: `Bearer ${token}`, "Accept-Language": currentLang },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to get tax details!";
      return rejectWithValue(message);
    }
  }
);

// toggle tax status
export const toggleTaxStatus = createAsyncThunk(
  "Tax/toggleTaxStatus",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const url = `${BASE_URL}/taxes/${id}/toggle-status`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Accept-Language": currentLang,
        "Content-Type": "application/json",
      };
      if (typeof navigator !== 'undefined' && !navigator.onLine) {
        await saveRequest({
          url,
          method: 'PATCH',
          headers: { ...headers, 'Content-Type': 'application/json' },
          formData: { bodyType: 'json', data: {} }, // body = {}
        });
        return { message: 'تم حفظ العملية وستتم مزامنتها عند عودة الإنترنت' };
      } else {
        const response = await axios.patch(url, {}, { headers });
        return response.data;
      }
    } catch (error) {
      const message = error.response?.data?.message || "Failed to toggle tax status!";
      return rejectWithValue(message);
    }
  }
);

// delete tax
export const deleteTax = createAsyncThunk(
  "Tax/deleteTax",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const url = `${BASE_URL}/taxes/${id}`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Accept-Language": currentLang,
      };
      if (typeof navigator !== 'undefined' && !navigator.onLine) {
        // أوفلاين: أضف الطلب للطابور
        await saveRequest({
          url,
          method: 'DELETE',
          headers,
          formData: null,
        });
        return { message: 'تم حفظ عملية الحذف وستتم مزامنتها عند عودة الإنترنت' };
      } else {
        const response = await axios.delete(url, { headers });
        return response.data;
      }
    } catch (error) {
      const message = error.response?.data?.message || "Failed to delete tax!";
      return rejectWithValue(message);
    }
  }
);